(() => {
  const normalize = value => String(value).toLocaleLowerCase().replace(/[\s×x-]+/g, '');
  const splitModels = value => {
    const seen = new Set();
    return String(value).slice(0, 200).split(',').map(item => item.trim()).filter(item => {
      const key = normalize(item);
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    });
  };
  const emailBody = entries => entries.filter(([name, value]) => name.startsWith('contact[') && String(value).trim() && name !== 'contact[request source]').map(([name, value]) => `${name.slice(8, -1)}: ${value}`).join('\n\n');
  const readRequest = search => {
    const p = new URLSearchParams(search);
    const text = key => (p.get(key) || '').replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, 200);
    return {
      model: text('model'), query: text('q'),
      quantity: /^[1-9]\d{0,2}$/.test(p.get('quantity') || '') ? p.get('quantity') : '1',
      intent: ['help','bulk','quote'].includes(p.get('intent')) ? p.get('intent') : 'quote',
      deck: ['24x36','24x48','30x60'].includes(p.get('deck')) ? p.get('deck') : '',
      material: ['steel','hardwood'].includes(p.get('material')) ? p.get('material') : ''
    };
  };
  const filterModels = (models, criteria) => {
    const query = normalize(criteria.query || '');
    const output = models.filter(model => normalize(model.search).includes(query) && (!criteria.deck || model.deck === criteria.deck) && (!criteria.material || model.material === criteria.material));
    if (criteria.sort === 'price-asc' || criteria.sort === 'price-desc') output.sort((a,b)=>(Number(a.price)-Number(b.price))*(criteria.sort === 'price-desc' ? -1 : 1));
    return output;
  };
  const toggleSelection = (selection, model, add) => {
    const output = [...new Set(selection)];
    if (!add) return {models:output.filter(item=>item!==model),limit:false};
    if (output.includes(model)) return {models:output,limit:false};
    if (output.length >= 3) return {models:output,limit:true};
    return {models:[...output,model],limit:false};
  };
  const quotePath = (contactPath, selection, origin) => {
    const url = new URL(contactPath, origin);
    if (url.origin !== origin) throw new Error('Quote requests must stay on the store.');
    url.searchParams.set('model',selection.slice(0,3).join(', '));
    url.searchParams.set('quantity','1');url.searchParams.set('intent',selection.length>1?'bulk':'quote');
    return url.pathname + url.search;
  };
  window.CRSBuyer = Object.freeze({readRequest,filterModels,toggleSelection,quotePath,splitModels,emailBody});
})();
